<template>
  <CModal title="Search People" size="xl" :show="show" :close-on-backdrop="false" add-content-classes="people-search-modal" @update:show="$emit('update:show', $event)">
    <CRow>
      <CCol md="7">
        <CInput v-model="search" placeholder="Name or email" @keyup.enter="load(1)" />
      </CCol>
      <CCol md="3">
        <select v-model="status" class="form-control" @change="load(1)">
          <option value="">All status</option>
          <option value="member">member</option>
          <option value="newcomer">newcomer</option>
          <option value="visitor">visitor</option>
        </select>
      </CCol>
      <CCol md="2">
        <CButton color="info" block :disabled="loading" @click="load(1)">{{ loading ? '...' : 'Search' }}</CButton>
      </CCol>
    </CRow>

    <CAlert v-if="error" color="danger">{{ error }}</CAlert>

    <div class="table-responsive mt-2">
      <table class="table table-hover table-sm">
        <thead><tr><th>Name</th><th>Email</th><th>Date of Birth</th><th>Status</th><th></th></tr></thead>
        <tbody>
          <tr v-for="row in rows" :key="row.uuid" :class="{ 'text-muted': isExcluded(row.uuid) }">
            <td><strong>{{ row.name }}</strong></td>
            <td>{{ row.email || '-' }}</td>
            <td>{{ row.dob || '-' }}</td>
            <td>{{ row.status || '-' }}</td>
            <td class="text-right">
              <CBadge v-if="isExcluded(row.uuid)" color="secondary">already linked</CBadge>
              <CButton v-else size="sm" color="success" variant="outline" @click="choose(row)">Select</CButton>
            </td>
          </tr>
          <tr v-if="!loading && !rows.length">
            <td colspan="5" class="text-center text-muted py-4">{{ searched ? 'No people matched.' : 'Type a name and press Search.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="pagination.total" class="d-flex justify-content-between align-items-center">
      <small class="text-muted">{{ pagination.total }} people</small>
      <div>
        <CButton size="sm" variant="outline" color="secondary" class="mr-2" :disabled="pagination.current_page <= 1 || loading" @click="load(pagination.current_page - 1)">Previous</CButton>
        <span>Page {{ pagination.current_page }} / {{ pagination.last_page }}</span>
        <CButton size="sm" variant="outline" color="secondary" class="ml-2" :disabled="pagination.current_page >= pagination.last_page || loading" @click="load(pagination.current_page + 1)">Next</CButton>
      </div>
    </div>

    <template #footer>
      <CButton color="secondary" @click="$emit('update:show', false)">Close</CButton>
    </template>
  </CModal>
</template>

<script>
import certificate from '@/services/certificate'

export default {
  name: 'CertificatePeopleSearchModal',
  props: {
    show: { type: Boolean, default: false },
    excludeUuids: { type: Array, default: () => [] }
  },
  data () {
    return { search: '', status: '', rows: [], loading: false, searched: false, error: '', pagination: { current_page: 1, last_page: 1, total: 0 } }
  },
  watch: {
    show (value) { if (value) this.reset() }
  },
  methods: {
    reset () { this.search = ''; this.status = ''; this.rows = []; this.searched = false; this.error = ''; this.pagination = { current_page: 1, last_page: 1, total: 0 } },
    isExcluded (uuid) { return this.excludeUuids.includes(uuid) },
    async load (page) {
      this.loading = true
      this.error = ''
      try {
        const result = await certificate.searchPeople({ search: this.search, status: this.status, page: page || 1 })
        this.rows = (result.data && result.data.data) || []
        this.pagination = result.data || { current_page: 1, last_page: 1, total: 0 }
        this.searched = true
      } catch (error) {
        const data = error.response && error.response.data
        this.error = (data && data.message) || error.message || 'Search failed.'
        this.rows = []
      } finally {
        this.loading = false
      }
    },
    choose (row) {
      this.$emit('select', { uuid: row.uuid, name: row.name, email: row.email, status: row.status })
      this.$emit('update:show', false)
    }
  }
}
</script>

<style>
.people-search-modal { z-index: 1060; }
</style>
